<template>
	<multiselect
		:disabled="disabled"
		class="w-100"
		placeholder="Search or add a tags"
		v-model="localValue"
		:options="options"
		:multiple="false"
		:taggable="true"
		:track-by="trackBy"
		:label="label"/>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
	components:{
		Multiselect
	},
	props:{
		value: [Number, String],
		options: Array,
		trackBy: String,
		label:String,
		taggable: {
				type: Boolean,
				default: false
		},
		disabled:{type:[String, Boolean], default: false}
	},
	data(){
		return {
			localValue:this.options[this.options.findIndex(option => option.value === this.value)],
		}
	},
	watch: {
		localValue (input) {
			//devuelve v-model del compoente : Eje: 1
			//existe input
			if(input){
				this.$emit('input', input.value);
			}
		},
		value () {
			//obtiene v-model del seletect:	 Ej:  {value: 2, text: 'Option label'}
			let index = this.options.findIndex(option => option.value === this.value);
			this.localValue = this.options[index];
		}
	}
}
</script>

<style>
/* .multiselect__single {
  white-space: nowrap;
  overflow: hidden;
} */
/* .multiselect__content-wrapper {
	position: static;
}
.multiselect__content-wrapper {
  position:absolute;
  display: block;
  background: #fff;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 50;
  -webkit-overflow-scrolling: touch
} */
</style>
